<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'
  export default {
    provide () {
      return {
        reload:this.reload,
      }
    },
    data() {
      return {
        isRouterAlive:true,
        scrollHeight:''
      }
    },
    rootPath: "http://pc.dodosurvey.com/cms", //后台接口路径
    rootSrcIp:"http://219.76.189.61:82/",
    userId:'',
    //rootPath: "http://demo14.embraiz.com/dodo40_monkeytree", //后台接口路径
    watch: {
      '$store.state.theme'(val) {
        this.toggleClassInBody(val)
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },
      toggleClassInBody(className) {
        if (className == 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
          document.body.classList.add('theme-dark')
        } else if (className == 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          document.body.classList.add('theme-semi-dark')
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        }
      },
      handleWindowResize() {
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      },
      handleScroll() {
        this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
      }
    },
    mounted() {
      this.toggleClassInBody(themeConfig.theme)
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    },
    async created() {
      window.addEventListener('resize', this.handleWindowResize)
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleScroll)
    },
  }

</script>
